import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { WINDOW } from '@campus/browser';
import { ENVIRONMENT_LOGIN_TOKEN } from '@campus/environment';
import { PersonWithToken } from '../kabas.interfaces';

@Injectable({
  providedIn: 'root',
})
export class RedirectService {
  private environment = inject(ENVIRONMENT_LOGIN_TOKEN);
  private window = inject(WINDOW);
  private router = inject(Router);

  toPlatform(user: PersonWithToken) {
    if (!user) return;

    const { types } = user;
    const type = types?.[0] || 'teacher';
    const url = this.getPlatformUrl(type);

    this.redirect(url);
  }

  getPlatformUrl(type: string) {
    return this.environment[`${type}AppUrl`] || this.environment.teacherAppUrl;
  }

  redirect(url: string) {
    if (/^(https?:)?\/\//.test(url)) {
      this.window.location.assign(url);
    } else {
      this.router.navigateByUrl(url);
      document.querySelector('dcr-app-shell')?.shadowRoot.querySelector('main')?.scrollTo({ left: 0, top: 0 });
    }
  }
}
